/**
 * Phase 76: Centralized app key constants for access gating.
 *
 * Single source of truth for the frontend. Backend mirror:
 * packages/identity-domain/src/identity_domain/constants.py
 *
 * Usage:
 *   import { APP_KEYS, type AppKey } from '@config/appKeys'
 *   hasAccess(APP_KEYS.COMPAS)
 */

/** All gatable applications in the platform */
export const APP_KEYS = {
  COMPAS: 'compas',
  CANTERA: 'cantera',
  KNOWLEDGE: 'knowledge',
  USERS: 'users',
  PERMISOS: 'permisos',
  PLATAFORMA: 'plataforma',
  BANRURAL: 'banrural',
} as const

/** Union type of all valid app key values */
export type AppKey = typeof APP_KEYS[keyof typeof APP_KEYS]

/** Admin-only apps (visible in "Administracion" sidebar section) */
export const ADMIN_APP_KEYS: readonly AppKey[] = [
  APP_KEYS.KNOWLEDGE,
  APP_KEYS.USERS,
  APP_KEYS.PERMISOS,
  APP_KEYS.PLATAFORMA,
]

/** Spanish display names for UI (access-denied messages, Permisos tab, etc.) */
export const APP_DISPLAY_NAMES: Record<AppKey, string> = {
  [APP_KEYS.COMPAS]: 'Compas (Chat)',
  [APP_KEYS.CANTERA]: 'Cantera (Pipeline)',
  [APP_KEYS.KNOWLEDGE]: 'Gestión de Conocimiento',
  [APP_KEYS.USERS]: 'Gestión de Usuarios',
  [APP_KEYS.PERMISOS]: 'Permisos',
  [APP_KEYS.PLATAFORMA]: 'Plataforma',
  [APP_KEYS.BANRURAL]: 'Banrural',
}
